import React from 'react'
import EditableSpan from '../EditableSpan'
import { Select, SelectAsync } from '../Select'

const InlineSelectElement = ({
  onBlur = () => {},
  onChange = () => {},
  value,
  ...props
}) => {
  
  return (
    <Select
      autoFocus
      openMenuOnFocus
      onBlur={onBlur}
      value={ value }
      onChange={(value) => onChange(value)}
      {...props}
    />
  )
}

const AsyncInlineSelectElement = ({
  onBlur = () => {},
  onChange = () => {},
  value,
  ...props
}) => {
  return (
    <SelectAsync
      autoFocus
      openMenuOnFocus
      onBlur={onBlur}
      value={ value }
      onChange={(value) => onChange(value)}
      {...props}
    />
  )
}

export const SelectInline = (props) => (
  <EditableSpan {...props} inlineElementType="InlineSelectElement" inlineElement={InlineSelectElement} />
)

export const SelectAsyncInline = (props) => (
  <EditableSpan {...props} inlineElementType="AsyncInlineSelectElement" inlineElement={AsyncInlineSelectElement} />
)
